module.exports = __webpack_public_path__ + "media/high_school_students/hs_joinbottom-21cf695f.png";